import { render, staticRenderFns } from "./MetadataLink.vue?vue&type=template&id=0696c330&"
import script from "./MetadataLink.vue?vue&type=script&lang=js&"
export * from "./MetadataLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports